'use client';
import { useIsDesktop } from '@/_hooks/useBreakpoint';
import { ISingleOrder } from '@/_service/types/orders';

import Desktop from './responsive/desktop';
import Mobile from './responsive/mobile';

const OrderDetails = ({
  order,
  total,
  change,
}: {
  order: ISingleOrder;
  total: number;
  change: number;
}) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <Desktop order={order} total={total} change={change} />
  ) : (
    <Mobile order={order} total={total} change={change} />
  );
};

export default OrderDetails;
